import React from 'react';
import GoogleCalendarSettings from './GoogleCalendarSettings';
import ActiveSubscriptionsPanel from './ActiveSubscriptionsPanel';

interface SettingsPageProps {}

const SettingsPage: React.FC<SettingsPageProps> = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">
        Configurações
      </h1>
      
      <div className="space-y-6">
        {/* Assinaturas Ativas */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <ActiveSubscriptionsPanel />
        </div>

        <GoogleCalendarSettings />
        
        {/* Espaço reservado para futuros componentes de configuração */}
        {/* Exemplos futuros:
            <ProfileSettings />
            <PaymentSettings />
            <NotificationSettings />
            <SecuritySettings />
        */}
      </div>
    </div>
  );
};

export default SettingsPage;